import { TemplateRef } from "@angular/core";
import { Observable } from "rxjs";
import { DynamicField } from "./dynamic-field.model";

export class DynamicFieldTemplate<T> extends DynamicField<T> {

    templateRef?: TemplateRef<any>;
    templateRefObserver?: Observable<TemplateRef<any>>;
    name?: string;
    data?: T;
    dataObserver?: Observable<T>;

    constructor(source: Partial<DynamicFieldTemplate<T>>) {
        super();
        Object.assign(this, source);

        this.templateRefObserver?.subscribe(data => {
            this.templateRef = data;
        });

        this.dataObserver?.subscribe(data => {
            this.data = data;
        });
    }
}